<template>
<div class="containerWrapper">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
          <h1>Orderadmin</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <br/><br/>
        <label>Orderid</label><br/>
        <InputText type="text" v-model="id" name="id" /><br/><br/>
        <Button label="Hämta order" @click="getOrder()"/>
      </div>
      <div class="col-md-6">
        <div v-if="order !== null">
          <br/><br/>
          <label>Status</label><br/>
          <InputText type="text" name="state" v-model="order.state" /><br/><br/>
          <label>Data</label><br/>
          <v-json-editor class="jsonEditor" :data="order.data" :editable="true" @change="$forceUpdate()"></v-json-editor><br/><br/>
          <Button label="Spara" @click="saveOrder()"/>
        </div>
      </div>
    </div>
  </div>
  <Toast position="topright" />
</div>
</template>
<script>
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import Toast from 'primevue/toast'
export default {
  name: 'Orderadmin',
  components: {
    InputText,
    Button,
    Textarea,
    Toast
  },
  data () {
    return {
      id: null,
      order: null
    }
  },
  methods: {
    async getOrder () {
      let response = await this.$http.get('/api/orders/' + this.id)
      this.order = response.data
    },
    saveOrder () {
      var url = '/api/orders/manual/' + this.order.id
      this.$http
        .put(url, {
          order: {
            id: this.order.id,
            state: this.order.state,
            data: this.order.data
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Order sparad', life: 3000})
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/OrderAdmin.vue